import ToolTip from '../../../common/StyledToolTip';
import ToolTipWithScroll from '../../../common/StyledToolTipWithScroll';
import { withStyles, withTheme } from "@material-ui/core";
import appConstant from "../../../../appConstants";
import { getSvgIcons } from "../../../modules/Dispatch/utils/iconsUtil";
import { compose } from "recompose";
import {
  isStopHasCodAmountShipments,
  isStopHasFreightAmountShipments,
  getCodIconTooltip
} from '../../../modules/Dispatch/utils/utils';
import RenderSpecialInstructions from "./RenderSpecialInstructions";
import { getExcessiveLengthCodeTooltip, getCustomerShipperCommentsTooltip } from '../../../modules/utils';
import { getEquipmentSizeTooltipContent } from '../../../modules/CustomerManagement/utils';
import { createDowSpecialNeeds } from '../../../../utilities/dowUtils';

const styles = (theme) => ({
  iconsContainer: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  iconStyle: {
    marginRight: 5,
    "& svg": {
      display: "block",
    },
  },
  // adding padding to the svg icon as mui icons have default padding
  svgIconWrapper: {
    display: "inline-block",
    padding: "2px",
  }
});



export const getCombinedIcons = (params, options) => {
  const specialNeeds = {};
  const combinedIconsArray = [];
  const SpecialNeedsList = options || appConstant.SpecialNeeds;
  SpecialNeedsList.forEach((data) => (specialNeeds[data.value] = data));
  if (Array.isArray(params.value) && params.value.length > 0) {
    return getCombinedIconArray(params, specialNeeds);
  }
  return combinedIconsArray;
};

const getSpecialInstructionForDriver = (data) => {
  return data.stops.map((stop) => getSpecialInstructionForDeliveryStop(stop));
};

const getSpecialInstructionForDeliveryStop = (stopData) => {
  return stopData.shipments.reduce((allSpecialInstructions, shipment) => {
    if (shipment.specialInstructions || shipment.drComments?.length) {
      return [...allSpecialInstructions, <RenderSpecialInstructions shipment={shipment}/>];
    }
    return allSpecialInstructions;
  }, []);
};

const getIconType = (specialNeedObject) => {
  return (
    specialNeedObject.icon || specialNeedObject.svgIcon || specialNeedObject.materialIcon || ''
  );
}

const getCombinedIconArray = (params, specialNeeds) => {
  const combinedIconsArray = [];

  const specialNeedsHandledSeparately = [
    appConstant.SpecialNeedsStrings.Unattended,
    appConstant.SpecialNeedsStrings.RESUNA
  ];

  params.value.forEach((value) => {
    const iconDetails = specialNeeds[value];
    const iconValue = iconDetails ? getIconType(iconDetails) : "";
    const isSvgIcon = Boolean(iconDetails?.svgIcon) ?? false;
    const isMaterialIcon = Boolean(iconDetails?.materialIcon) ?? false;
    if (value === appConstant.SpecialNeedsStrings.APT) {
      const aptWindow = params.getAPTWindow?.(params);
      const aptWindowTooltipMsg = aptWindow
        ? `${appConstant.SpecialNeedsStrings.APT} from ${aptWindow}`
        : appConstant.SpecialNeedsStrings.APT;
      const aptComments = params.data.aptComments || params.getAptComments?.(params);
      combinedIconsArray.push({
        icon: iconValue,
        isSvgIcon,
        tooltip: (
          <>
            {aptWindowTooltipMsg}
            {aptComments && (
              <>
                <br />
                {aptComments}
              </>
            )}
          </>
        )
      });
    } else if (value === appConstant.SpecialNeedsStrings.SI) {
      //we are not showing specialInstruction for route
      if (
        (params.data.stopType === appConstant.STOP_TYPE.Delivery &&
          params.data.shipments?.length) ||
        params.data.stops?.length
      ) {
        const tooltip = params.data.stops?.length
          ? getSpecialInstructionForDriver(params.data)
          : getSpecialInstructionForDeliveryStop(params.data);
        combinedIconsArray.push({
          icon: iconValue,
          isSvgIcon,
          tooltip,
          toolTipWithScroll: true
        });
      } else {
        combinedIconsArray.push({
          icon: iconValue,
          isSvgIcon,
          tooltip:
            params.data.specialInstruction ||
            params.data.specialInstructions ||
            params.data.shipmentSpecialInstruction,
        });
      }
    } else if (value === appConstant.SpecialNeedsStrings.COD) {
      const isCodCharge =
        params.data.isCodCharge ||
        params.data.stops?.some((stop) => isStopHasCodAmountShipments(stop.shipments)) ||
        isStopHasCodAmountShipments(params.data.shipments);
      const isFreightCharge =
        params.data.isFreightCharge ||
        params.data.stops?.some((stop) => isStopHasFreightAmountShipments(stop.shipments)) ||
        isStopHasFreightAmountShipments(params.data.shipments);
      const tooltip = getCodIconTooltip(isCodCharge, isFreightCharge);
      combinedIconsArray.push({
        icon: iconValue,
        isSvgIcon,
        tooltip
      });
    } else if (value === appConstant.SpecialNeedsStrings.ExcessiveLength) {
      const tooltip = getExcessiveLengthCodeTooltip({
        baseTooltip: iconDetails?.tooltip,
        excessiveLengthCode: params.data.excessiveLengthCode
      });
      combinedIconsArray.push({
        icon: iconValue,
        isSvgIcon,
        isMaterialIcon,
        tooltip
      });
    } else if (
      [
        appConstant.SpecialNeedsStrings.CC,
        appConstant.SpecialNeedsStrings.SC,
      ].includes(value)
    ) {
      const tooltip = getCustomerShipperCommentsTooltip(value,params);
      combinedIconsArray.push({
        icon: iconValue,
        isSvgIcon,
        tooltip,
        toolTipWithScroll: true
      });
    } else if (value === appConstant.SpecialNeedsStrings.EQS) {
      const tooltipContent = getEquipmentSizeTooltipContent(params.data);
      if (tooltipContent) {
        combinedIconsArray.push({
          icon: iconValue,
          isSvgIcon,
          isMaterialIcon,
          tooltip: tooltipContent
        });
      }
    } else if (value === appConstant.SpecialNeedsStrings.DOW) {
      const dowSpecialNeeds = createDowSpecialNeeds(params.data.deliveryDowOpen, params.context?.planDate);
     if(dowSpecialNeeds){
      combinedIconsArray.push({
        icon: iconValue,
          text: dowSpecialNeeds.text,
          isSvgIcon,
          tooltip: dowSpecialNeeds.tooltip
        });
      }
    }
    else if (!specialNeedsHandledSeparately.includes(value)){
      // Only if the special need is not handled separately
      combinedIconsArray.push({
        icon: iconValue,
        isSvgIcon,
        isMaterialIcon,
        tooltip: iconDetails ? iconDetails.tooltip : "",
      });
    }
  });

  const groupedIconsArray = getGroupedSpecialNeedsIcon(params, specialNeeds);
  return [...combinedIconsArray, ...groupedIconsArray];
};

const getGroupedSpecialNeedsIcon = (params, specialNeeds) => {
  const groupedIconsArray = [];
  const {SpecialNeedsStrings} = appConstant;

  // Unattended delivery
  const hasUnattendedDelivery =
    params.value.includes(SpecialNeedsStrings.Unattended) ||
    params.value.includes(SpecialNeedsStrings.RESUNA);

  if (hasUnattendedDelivery) {
    const iconDetails = specialNeeds[SpecialNeedsStrings.Unattended];
    const iconValue = iconDetails ? getIconType(iconDetails) : "";
    const isSvgIcon = Boolean(iconDetails?.svgIcon);
    const tooltip = iconDetails?.tooltip || "";
    groupedIconsArray.push({
      icon: iconValue,
      isSvgIcon,
      tooltip
    });
  }
  return groupedIconsArray;
};

const getIconColorBySection = (params) => {
  const { theme, renderSection } = params;
  switch (renderSection) {
    case appConstant.SPECIAL_NEEDS_SECTION_TYPE.PRINT_SECTION:
      return theme.printTableValue;
    case appConstant.SPECIAL_NEEDS_SECTION_TYPE.DRAWER_SECTION:
      return theme.dispatchPanelLabelValueColor;
    default:
      return theme.gridTextColor;
  }
};

const SpecialNeedsRenderer = (params) => {
  const options = params.context?.specialNeedsOptions;
  const { classes } = params;
  const iconsList = getCombinedIcons(params, options);
  if (iconsList.length === 0) {
    return null;
  }
  const getIcon = (icons) => {
  
    if (icons.isSvgIcon) { 
      const iconColor = getIconColorBySection(params);
      return (
        <span className={classes.svgIconWrapper}>
          {getSvgIcons({iconName: icons.icon, backgroundColor: iconColor, label: icons?.text})}
        </span>
      );
    }
    return <i className={`${icons.icon}`} />;
  };
  return (
    <div className={classes.iconsContainer} style={params.printStyles}>
      {iconsList.map((icons, index) => {
        const TooltipComponent = icons.toolTipWithScroll ? ToolTipWithScroll : ToolTip;
        //if you are making the style changes to this component, please verify it with loading guide once
        return (
          <TooltipComponent key={index} title={icons.tooltip} >
            <div className={params.printStyles ? "": classes.iconStyle}>{getIcon(icons)}</div>
          </TooltipComponent>
        );
      })}
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(SpecialNeedsRenderer);
